import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Cluster } from 'src/app/core/cluster.service';

@Component({
  selector: 'app-cluster-data-table',
  templateUrl: './cluster-data-table.component.html',
  styleUrls: ['./cluster-data-table.component.scss'],
})
export class ClusterDataTableComponent {
  @Input() clusters: Cluster[] = [];
  @Output() scrolledToEnd: EventEmitter<void> = new EventEmitter<void>();

  displayed_columns: string[] = ['cluster_id', 'cluster_code', 'name', 'actions'];

  constructor(private router: Router) {}

  onDetailClick(cluster: Cluster): void {
    this.router.navigate(['/cluster', cluster.cluster_id]);
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const end_offset = 200;
    if (element) {
      if (element.offsetHeight + element.scrollTop >= element.scrollHeight - end_offset) {
        this.scrolledToEnd.emit();
      }
    }
  }
}
